import { render, staticRenderFns } from "./gym.vue?vue&type=template&id=1fc938de&scoped=true&"
import script from "./gym.vue?vue&type=script&lang=js&"
export * from "./gym.vue?vue&type=script&lang=js&"
import style0 from "./gym.vue?vue&type=style&index=0&id=1fc938de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc938de",
  null
  
)

export default component.exports